export default __webpack_public_path__ + "locales/sr-Cyrl-RS/VersionHistory.json?hash=e043f998715e53de24dc505a57c62d2a";